import {Game} from "../Game";
import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import { GameModeNames } from "../server/GameModeNames";
import {Sound} from "../sound/Sound";

export class BigWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return ((Game.model.isBigWin && !Game.isSingleWinBelowStake() && !Game.isMaxWinByMXSymbol()) || (!Game.isMaxWinByMXSymbol() && Game.model.gameData.brokeTheBank));
    }

    public start(controller: ISimplePresentationRunnerController): void {
        Game.soundPlayer.fadeOutBGSound();
        Game.soundPlayer.playSound(Sound.BIG_WIN_INTRO, 1);
        Game.bigWin.playBigWin(controller);
    }
}